import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/internal/Subscription';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

import {
  confirmRefundResponse,
  getRefundResponse,
} from '../../store/transaction';
import {
  ConfirmTransactionRefund,
  GetTransactionRefund,
  TransactionStatus,
} from '../../store/transaction/transaction.actions';
import { BaseComponent } from '../../shared/base.component';
import {
  CancellationReasonConfig,
  cancelReasons,
  RefundModalData,
  SelectedOption,
  SelectedSubOption,
  subReasonCodes,
  SummarySectionData,
  TransactionData,
} from '../transaction-status.model';
import { StringUtils } from '../../shared/utils/string-utils';
import { RefundResponse } from '../../store/transaction/types';
import { PageTitles } from 'src/app/config/app-config';

@Component({
  selector: 'app-transaction-status-modal',
  templateUrl: './transaction-status-modal.component.html',
  styleUrls: ['./transaction-status-modal.component.scss'],
})
export class TransactionStatusgModalComponent
  extends BaseComponent
  implements OnInit
{
  transactionData: RefundModalData;
  refundDetails: TransactionData;
  cmsLabels: any;
  public form?: FormGroup;
  getRefundResponse: RefundResponse;
  confirmWalletMemo: number | string = '';
  selectedReason: string = '';
  selectedSubReason: string = '';
  reasons: CancellationReasonConfig[] = this.shuffleArray(cancelReasons);
  subReasonCodes: CancellationReasonConfig[] = subReasonCodes;
  reasonOption: Observable<any[]>;
  reasonSubOption: Observable<any[]>;
  arrowIcon: string = 'keyboard_arrow_down';
  displaySelectReason: boolean = true;
  referenceNumber: string | number = '';
  reasonDetails: SummarySectionData;
  codesRequireSub = ['NL_NO_RCV_LOC'];
  codesRequireTextBox = ['TECH_PROB', 'LOC_OTH', 'OTHER'];
  textBoxLabelCodes = ['LOC_OTH', 'TECH_PROB', 'OTHER'];
  TextBoxLabel: string;
  isSubTaskReq = false;
  isTextBoxReq = false;
  remainCharLen = 0;
  textBoxCharLen = 0;
  reasonCodeLabels: any;
  reasonCodeTextError: any;
  endpoint: string;
  reasonControl = this._fb.control('', [Validators.required]);
  subReasonControl = this._fb.control('', [Validators.required]);
  textAreaControl = this._fb.control('', [
    Validators.required,
    Validators.maxLength(500),
  ]);

  @Output() public valueChanges: EventEmitter<any> = new EventEmitter<any>();
  private _watches: Subscription[] = [];

  private locale: string = 'en-US';
  public dataLayer = ((<any>window).dataLayer = (<any>window).dataLayer || []);

  public get value() {
    const currentVal = this.form?.getRawValue();
    return (
      currentVal && {
        ...currentVal,
        reason: currentVal.reason,
      }
    );
  }
  constructor(
    private dialogRef: MatDialogRef<TransactionStatusgModalComponent>,
    private store: Store<any>,
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {
    super();
  }

  ngOnInit() {
    if (this.dialogData && this.dialogData.params) {
      this.transactionData = this.dialogData.params.transactionData;
      this.referenceNumber = this.transactionData.queryRefNumber;
      this.locale = this.dialogData.params.locale;
      this.cmsLabels = this.dialogData.params.cmsLabels;
      this.reasonCodeLabels =
        this.cmsLabels?.stellar?.refundCancelReasons.reasonCodeLabels;
      this.reasonCodeTextError =
        this.cmsLabels?.stellar?.refundCancelReasons.reasonCodeTextError;
      this.endpoint = this.dialogData.params.endpoint;
      if (this.cmsLabels && this.reasons) {
        const cmsReasonCodes =
          this.cmsLabels?.stellar?.refundCancelReasons.reasonCodes;
        const filteredReasons = Object.keys(cmsReasonCodes).filter((reason) =>
          cancelReasons.some((r) => r.value === reason)
        );
        if (cmsReasonCodes) {
          this.reasons = filteredReasons.map((key) => ({
            value: key,
            description: cmsReasonCodes[key],
          }));
        }

        const cmsSubReasonCodes =
          this.cmsLabels?.stellar?.refundCancelReasons.subReasonCodes;
        const filteredSubReasons = Object.keys(cmsSubReasonCodes).filter(
          (reason) => {
            return subReasonCodes.some((r) => r.value === reason);
          }
        );
        if (cmsSubReasonCodes) {
          this.subReasonCodes = filteredSubReasons.map((key) => ({
            value: key,
            description: cmsSubReasonCodes[key],
          }));
        }
      }
    }
    this.reasonDetails = {
      sections: [
        {
          title: this.cmsLabels.stellar.costSummary,
          items: [
            {
              name: this.cmsLabels.stellar.cancel.kind,
              value: this.cmsLabels.stellar.cancel.cashOut,
            },
          ],
        },
      ],
    };

    this.reasonDetails = {
      sections: [
        {
          title: this.cmsLabels.stellar.costSummary,
          items: [
            {
              name: this.cmsLabels.stellar.estimateConfirmation.purchaseAmount,
              value: `${this.transactionData.amountDetails.value.toFixed(2)} ${
                this.transactionData.amountDetails.currencyCode
              }`,
            },
            {
              name: this.cmsLabels.stellar.cancel.kind,
              value: this.cmsLabels.stellar.cancel.cashOut,
            },
          ],
        },
      ],
    };

    this.reasonDetails = {
      sections: [
        {
          title: this.cmsLabels.stellar.costSummary,
          items: [
            {
              name: this.cmsLabels.stellar.estimateConfirmation.purchaseAmount,
              value: `${this.transactionData.amountDetails.value.toFixed(2)} ${
                this.transactionData.amountDetails.currencyCode
              }`,
            },
            {
              name: this.cmsLabels.stellar.cancel.kind,
              value: this.cmsLabels.stellar.cancel.cashOut,
            },
          ],
        },
      ],
    };

    this.store.select(getRefundResponse).subscribe((response) => {
      this.getRefundResponse = response;
      if (!this.isEmpty(response)) {
        this.refundDetails = {
          sections: [
            {
              title: this.cmsLabels.costSummary,
              items: [
                {
                  name: this.cmsLabels.stellar.estimateConfirmation
                    .purchaseAmount,
                  value: `${response?.refundTotalAmount?.value.toFixed(2)}`,
                  sendCurrency: `${response?.refundTotalAmount?.currencyCode}`,
                },
                {
                  name: this.cmsLabels.stellar.cancel.kind,
                  value: this.cmsLabels.stellar.cancel.cashOut,
                },
              ],
            },
          ],
          transactionId: this.transactionData.transactionId,
          refNumber: this.transactionData.refNumber,
          queryRefNumber: this.transactionData.queryRefNumber,
        };
      }
    });

    this.store.select(confirmRefundResponse).subscribe((response) => {
      this.confirmWalletMemo = response?.settlementDetails?.walletMemo;
    });

    const controlsConfig: { [prop: string]: FormControl } = {
      reason: this.reasonControl,
      subReason: this.subReasonControl,
      textArea: this.textAreaControl,
    };

    this.form = this._fb.group(controlsConfig);
    this.reasonOption = this.form.get('reason')!.valueChanges.pipe(
      startWith(''),
      map((value) => this._getFilteredReasonOption(value || ''))
    );

    this.reasonSubOption = this.form.get('subReason')!.valueChanges.pipe(
      startWith(''),
      map((value) => this._getFilteredSubReasonOption(value || ''))
    );

    this._watches.push(
      this.form?.get('textArea')!.valueChanges.subscribe((comments) => {
        this.textBoxCharLen = comments.length;
        this.remainCharLen =
          comments && comments.length > 0 ? 500 - comments.length : 0;
      })
    );

    this._watches.push(
      this.reasonOption.subscribe((option) => {
        this.form?.get('reason')!.valueChanges.subscribe((selectedOption) => {
          const filteredReasonValue: string =
            StringUtils.removeDiacriticsAndConvertToLowercase(selectedOption);
          this.selectedReason = option?.find(
            (reason) =>
              StringUtils.removeDiacriticsAndConvertToLowercase(
                reason?.description
              ) ===
                StringUtils.removeDiacriticsAndConvertToLowercase(
                  filteredReasonValue
                ) ||
              StringUtils.removeDiacriticsAndConvertToLowercase(
                reason?.value
              ) ===
                StringUtils.removeDiacriticsAndConvertToLowercase(
                  filteredReasonValue
                )
          )?.value!;
          const filterValue = filteredReasonValue;
          if (this.selectedReason && this.form) {
            this.isSubTaskReq = this.codesRequireSub.includes(
              this.selectedReason
            );
            this.isTextBoxReq = this.codesRequireTextBox.includes(
              this.selectedReason
            );
            if (this.isTextBoxReq) {
              this.TextBoxLabel =
                this.reasonCodeLabels[`${this.selectedReason}_LABEL`];
              this.form.addControl('textArea', this.textAreaControl);
            } else if (this.form?.get('textArea')) {
              this.form.removeControl('textArea');
            }

            if (this.isSubTaskReq) {
              this.form.addControl('subReason', this.subReasonControl);
            } else if (this.form?.get('subReason')) {
              this.form.removeControl('subReason');
            }
          }
          if (filterValue && !option.length) {
            this.form?.get('reason')?.setErrors({ invalidOption: true });
          } else if (this.selectedReason) {
            this.form?.get('reason')?.setErrors(null);
          } else {
            if (this.isSubTaskReq && !this.selectedReason && this.form) {
              this.isSubTaskReq = this.codesRequireSub.includes(
                this.selectedReason
              );
              this.form?.get('subReason')?.setValue('');
              this.form?.get('subReason')?.markAsPristine();
              this?.form.get('subReason')?.markAsUntouched();
            }
            if (this.isTextBoxReq && !this.selectedReason && this.form) {
              this.isTextBoxReq = this.codesRequireSub.includes(
                this.selectedReason
              );
              this.form?.get('textArea')?.setValue('');
              this.form?.get('textArea')?.markAsPristine();
              this?.form.get('textArea')?.markAsUntouched();
            }
            this.form?.get('reason')?.setErrors({ invalidOption: true });
          }
        });
      })
    );
    this.dialogRef.addPanelClass('custom-dialog-without-close');

    this._watches.push(
      this.reasonSubOption.subscribe((option) => {
        if (this.form?.get('subReason')) {
          this.form
            ?.get('subReason')!
            .valueChanges.subscribe((subReasonOption) => {
              const filteredReasonValue: string =
                StringUtils.removeDiacriticsAndConvertToLowercase(
                  subReasonOption
                );
              this.selectedSubReason = option?.find(
                (reason) =>
                  StringUtils.removeDiacriticsAndConvertToLowercase(
                    reason?.description
                  ) ===
                    StringUtils.removeDiacriticsAndConvertToLowercase(
                      filteredReasonValue
                    ) ||
                  StringUtils.removeDiacriticsAndConvertToLowercase(
                    reason?.value
                  ) ===
                    StringUtils.removeDiacriticsAndConvertToLowercase(
                      filteredReasonValue
                    )
              )?.value!;
              const filterValue =
                StringUtils.removeDiacriticsAndConvertToLowercase(
                  filteredReasonValue
                );
              if (this.selectedSubReason && this.form) {
                this.isTextBoxReq = this.codesRequireTextBox.includes(
                  this.selectedSubReason
                );
                if (this.isTextBoxReq) {
                  this.TextBoxLabel =
                    this.reasonCodeLabels[`${this.selectedSubReason}_LABEL`];
                  this.form.addControl('textArea', this.textAreaControl);
                } else if (this.form?.get('textArea')) {
                  this.form.removeControl('textArea');
                }
              }
              if (filterValue && !option.length && !this.selectedSubReason) {
                this.form?.get('subReason')?.setErrors({ invalidOption: true });
              } else if (this.selectedSubReason) {
                this.form?.get('subReason')?.setErrors(null);
              } else {
                if (this.isTextBoxReq && !this.selectedSubReason && this.form) {
                  this.isTextBoxReq = this.codesRequireSub.includes(
                    this.selectedSubReason
                  );
                  this.form?.get('textArea')?.setValue('');
                  this.form?.get('textArea')?.markAsPristine();
                  this?.form.get('textArea')?.markAsUntouched();
                }
                this.form?.get('subReason')?.setErrors({ invalidOption: true });
              }
            });
        }
      })
    );
  }

  getReasonOptionRawValue(form: SelectedOption): string {
    return typeof form.reason === 'object' && 'value' in form.reason
      ? StringUtils.removeDiacriticsAndConvertToLowercase(form.reason.value)
      : StringUtils.removeDiacriticsAndConvertToLowercase(form.reason);
  }

  getFilteredOptionRawValue(description: string): string {
    return StringUtils.removeDiacriticsAndConvertToLowercase(description);
  }

  getReasonSubOptionRawValue(form: SelectedSubOption): string {
    return typeof form.subReason === 'object' && 'value' in form.subReason
      ? StringUtils.removeDiacriticsAndConvertToLowercase(form.subReason.value)
      : StringUtils.removeDiacriticsAndConvertToLowercase(form.subReason);
  }

  getFilteredSubOptionRawValue(description: string): string {
    return StringUtils.removeDiacriticsAndConvertToLowercase(description);
  }

  getRefundReason(description: string) {
    return !!this.reasons && description
      ? this.reasons.find((reason) => {
          return (
            StringUtils.removeDiacriticsAndConvertToLowercase(
              reason.description
            ) === StringUtils.removeDiacriticsAndConvertToLowercase(description)
          );
        })
      : '';
  }

  private _getFilteredReasonOption(query: any): any {
    const filterValue: string =
      typeof query === 'string'
        ? StringUtils.removeDiacriticsAndConvertToLowercase(query)
        : StringUtils.removeDiacriticsAndConvertToLowercase(query?.description);
    return this.reasons.filter((reason: CancellationReasonConfig) => {
      return (
        reason.description &&
        StringUtils.removeDiacriticsAndConvertToLowercase(
          reason.description
        ).startsWith(filterValue)
      );
    });
  }

  private _getFilteredSubReasonOption(query: any): any {
    const filterValue: string =
      typeof query === 'string'
        ? StringUtils.removeDiacriticsAndConvertToLowercase(query)
        : StringUtils.removeDiacriticsAndConvertToLowercase(query?.description);
    return this.subReasonCodes.filter((reason: CancellationReasonConfig) => {
      return (
        reason.description &&
        StringUtils.removeDiacriticsAndConvertToLowercase(
          reason.description
        ).startsWith(filterValue)
      );
    });
  }

  displayWithFn(option: any) {
    return typeof option === 'object' && 'description' in option
      ? option.description
      : option;
  }

  onSubmit() {
    const payload = {
      userLanguage: this.locale || 'en-US',
      targetAudience: 'CONSUMER_FACING',
      refundReasonCode: this.selectedReason,
      sendAmount: {
        currencyCode: this.getRefundResponse?.refundTotalAmount?.currencyCode,
        value: this.getRefundResponse?.refundTotalAmount?.value,
      },
    };
    this._analyticsBtnClickEvent('confirmTransactionRefund');
    this.store.dispatch(
      ConfirmTransactionRefund({
        transactionId: this.transactionData?.transactionId,
        payload: payload,
        endpoint: this.endpoint,
      })
    );
  }

  selectReason() {
    this.store.dispatch(
      GetTransactionRefund({
        transactionId: this.transactionData?.transactionId,
        refundCancelReason: this.selectedReason,
        endpoint: this.endpoint,
      })
    );
    this.displaySelectReason = false;
  }

  onAutoCompletePanelToggle(isOpen: boolean) {
    if (isOpen) {
      this.arrowIcon = 'keyboard_arrow_up';
    } else {
      this.arrowIcon = 'keyboard_arrow_down';
    }
  }

  closeModal() {
    setTimeout(() => {
      this.dialogRef.close();
    }, 150);
    this.store.dispatch(
      TransactionStatus({
        transactionId: this.transactionData?.transactionId,
        refNumber: this.transactionData?.queryRefNumber,
        endpoint: this.endpoint,
      })
    );
  }

  closeCancelModal() {
    this.dialogRef.close();
  }

  textBoxCharLabels() {
    if (this.textBoxCharLen === 0) {
      return this.reasonCodeTextError.TEXT_BOX_MAX;
    } else if (this.remainCharLen >= 0) {
      return `${this.remainCharLen} ${this.reasonCodeTextError.CHAR_REMAIN}`;
    } else if (this.remainCharLen < 0) {
      return `${Math.abs(this.remainCharLen)} ${
        this.reasonCodeTextError.CHAR_OVER_LIMIT
      }`;
    } else {
      return this.reasonCodeTextError.TEXT_BOX_MAX;
    }
  }

  private getRefundCommitDetails(): any {
    let refundDetails: any = {
      refundReasonCode: this.selectedReason,
      sendAmount: {
        currencyCode: this.getRefundResponse?.refundTotalAmount?.currencyCode,
        value: this.getRefundResponse?.refundTotalAmount?.value,
      },
    };

    if (this.isSubTaskReq && this.selectedSubReason) {
      refundDetails = {
        ...refundDetails,
        refundSubReasonCode: this.selectedSubReason,
      };
    }

    if (this.isTextBoxReq && this.form?.get('textArea')) {
      refundDetails = {
        ...refundDetails,
        refundReasonComments: this.form?.get('textArea')?.value,
      };
    }

    return refundDetails;
  }

  isEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  private shuffleArray(arr: CancellationReasonConfig[]) {
    let array = arr;
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  private _analyticsBtnClickEvent(event: string) {
    const clickInfoObj = {};
    clickInfoObj['event'] = event;
    clickInfoObj['transaction-Id'] = this.transactionData?.transactionId;
    clickInfoObj['page-title'] = PageTitles.TRANSACTION_STATUS_PAGE;
    clickInfoObj['operation'] = this.transactionData?.flowType;
    if (event && event === 'confirmTransactionRefund') {
      clickInfoObj['refund-commit-details'] = this.getRefundCommitDetails();
    }
    this.dataLayer.push(clickInfoObj);
  }
}
